import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ATTENDANCE_MANAGEMENT_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const attendanceServiceApi = createApi({
  reducerPath: "attendanceServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: ATTENDANCE_MANAGEMENT_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetAttendanceSettingData",
    "GetOfficeSettingData",
    "GetCustomAttendanceByEmployee",
    "GetUnpaidLeavePolicy",
    "GetSelectedEmployees",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
